import { useEffect, useState } from 'react';
import useYasna from '../../yasna/useYasna';
import { describeSense } from './AnnotationRow';

/** The meaning of a yasna sense in words ("imiter (verb) — to imitate"), never its id. */
function SenseMeaning({ senseId }) {
  const { yasna } = useYasna();
  const [sense, setSense] = useState(null);
  useEffect(() => {
    if (!yasna || !senseId) return undefined;
    let cancelled = false;
    yasna.getById(senseId).then((s) => { if (!cancelled) setSense(s); }, () => {});
    return () => { cancelled = true; };
  }, [yasna, senseId]);
  return sense ? describeSense(sense) : null;
}

export default SenseMeaning;
